import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function LegalPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <section className="flex-1 max-w-4xl mx-auto px-6 py-16 w-full">
        <div className="mb-12">
          <h1 className="font-display text-4xl lg:text-5xl font-black mb-4">
            Legal & <span className="gold-grad">Terms</span>
          </h1>
          <p className="text-white/60 text-lg">
            Please read these legal documents carefully before using Duocapital services.
          </p>
        </div>

        {/* Terms of Service */}
        <div className="glass-strong rounded-2xl p-8 mb-8">
          <h2 className="font-display text-2xl font-bold mb-6 text-[#D4AF37]">Terms of Service</h2>
          
          <div className="space-y-6 text-white/70">
            <div>
              <h3 className="font-bold text-white mb-2">1. Acceptance of Terms</h3>
              <p>By accessing and using Duocapital, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">2. User Responsibilities</h3>
              <p>Users are responsible for maintaining confidentiality of account credentials and are fully responsible for all activities that occur under their account. Users agree to notify Duocapital immediately of any unauthorized use of their account.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">3. Investment Risk Disclosure</h3>
              <p>Cryptocurrency and investment trading are high-risk activities. Past performance does not guarantee future results. Users should only invest funds they can afford to lose entirely. Duocapital is not responsible for investment losses.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">4. Withdrawal & Payments</h3>
              <p>Withdrawals are processed within 24-48 hours of request approval. All payments are made to the wallet address specified by the user. Duocapital is not responsible for incorrect wallet addresses provided by users.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">5. AI Bot Subscription</h3>
              <p>Access to the AI Bot is provided via subscription tiers (Starter, Growth, Premium, Elite, Platinum). Subscription fees are non-refundable and grant access to AI-powered trading tools and loan eligibility as described on the platform.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">6. Limitation of Liability</h3>
              <p>Duocapital and its officers, agents, and employees will not be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with the use of this service.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">7. Modification of Terms</h3>
              <p>Duocapital reserves the right to modify these terms at any time. Users will be notified of significant changes via email. Continued use of the service after modifications constitutes acceptance of the new terms.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">8. Governing Law</h3>
              <p>These terms are governed by and construed in accordance with the laws of Malta, and you irrevocably submit to the exclusive jurisdiction of the courts located in Malta.</p>
            </div>
          </div>
        </div>

        {/* Privacy Policy */}
        <div className="glass-strong rounded-2xl p-8">
          <h2 className="font-display text-2xl font-bold mb-6 text-[#D4AF37]">Privacy Policy</h2>

          <div className="space-y-6 text-white/70">
            <div>
              <h3 className="font-bold text-white mb-2">1. Information Collection</h3>
              <p>We collect personal information including but not limited to: name, email address, phone number, residential address, and financial information necessary to process transactions and comply with regulatory requirements (KYC).</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">2. Data Usage</h3>
              <p>Your personal data is used to: provide services, process transactions, verify identity (KYC/AML), prevent fraud, comply with legal obligations, and improve user experience. We do not sell your personal data to third parties.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">3. Data Security</h3>
              <p>We implement industry-leading security measures including AES-256 encryption, SSL/TLS protocols, and regular security audits. All sensitive data is stored in secure, encrypted databases with restricted access.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">4. GDPR Compliance</h3>
              <p>For users in the EU, we comply with all GDPR requirements. You have the right to access, correct, or delete your personal data. Please contact privacy@duocapital.com to exercise these rights.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">5. Third-Party Sharing</h3>
              <p>We may share information with: payment processors, financial institutions, law enforcement (when required), and regulatory bodies. All third parties are bound by confidentiality agreements.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">6. Cookies & Tracking</h3>
              <p>We use cookies and similar technologies to enhance user experience and security. You can control cookie preferences through your browser settings. We do not track users across third-party websites.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">7. Data Retention</h3>
              <p>We retain user data for the duration of the account relationship and as required by law (typically 5-7 years for compliance purposes). Users may request data deletion in accordance with applicable laws.</p>
            </div>

            <div>
              <h3 className="font-bold text-white mb-2">8. Contact Us</h3>
              <p>For privacy concerns or inquiries, contact our Data Protection Officers at: noreply@duocapitall.com.</p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-blue-500/10 border border-blue-500/30 rounded-xl">
          <p className="text-sm text-white/70">
            Last Updated: January 20, 2023. For questions about our legal policies, please contact: noreply@duocapitall.com
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
